const textDefaults = {
	'EN': {
		'welcomeTitle': 'We need some information to validate your company.',
		'welcomeReason': 'The next page will guide you through this process.',
		'finishedTitle': 'Ready to submit',
		'finishedReason': 'On submitting, the data you provided will be carefully reviewed and additional checks might be necessary.',
		'vatText': 'Please provide the VAT number:',
		'lblVAT': 'VAT number',
		'unknownCompanyText': 'This VAT number is not recognised and cannot be validated, please recheck or enter all information manually.',
		'unknownCompanyBtn': 'Continue',
		'detailsText': 'Please review and adjust these details if required:',
		'detailsUnknownText': 'Please provide the following details',
		'scanningTitle': 'Upload your documents',
		'scanningText': 'Capture or select an image of your document where the edges are visible and all text is clearly readable.',
		'errorNotRecognised': 'Document not recognized',
		'errorWrongType': 'Wrong document type',
		'lblExpires': 'Expires',
		'lblUploadOrCapture': 'Upload or capture an image',
		'VATText': 'Please provide your VAT number',
		'lblBE': 'Belgium',
		'lblNonBE': 'Other country',
		'lblEER': 'EER Country (EU27 (incl. BE) / Iceland / Norway / Liechtenstein / Switzerland)',
		'lblNonEER': 'Other country',
		'employeeDetailText': 'Please provide the following information',
		'CountryLocationText': 'Where is your company registered?',
		'EmployeeLocationText': 'Where are you registered?',
		'selfEmployedText': 'Are you self-employed?',
		'yes': 'Yes',
		'no': 'No',
	},
	'FR': {
		'welcomeTitle': 'Nous avons besoin de quelques informations pour valider votre entreprise.',
		'welcomeReason': 'La page suivante vous guidera à travers ce processus.',
		'finishedTitle': 'Prêt à soumettre',
		'finishedReason': 'Après soumission, les données que vous avez fournies seront soigneusement examinées et des vérifications supplémentaires pourraient être nécessaires.',
		'vatText': 'Veuillez fournir le numéro de TVA :',
		'lblVAT': 'Numéro de TVA',
		'unknownCompanyText': 'Ce numéro de TVA n\'est pas reconnu et ne peut pas être validé, veuillez vérifier à nouveau ou saisir toutes les informations manuellement.',
		'unknownCompanyBtn': 'Continuer',
		'detailsText': 'Veuillez vérifier et ajuster ces détails si nécessaire :',
		'detailsUnknownText': 'Veuillez fournir les détails suivants',
		'scanningTitle': 'Téléchargez vos documents',
		'scanningText': 'Capturez ou sélectionnez une image de votre document où les bords sont visibles et tout le texte est clairement lisible.',
		'errorNotRecognised': 'Document non reconnu',
		'errorWrongType': 'Type de document incorrect',
		'lblExpires': 'Expire',
		'lblUploadOrCapture': 'Télécharger ou capturer une image',
		'VATText': 'Veuillez fournir votre numéro de TVA',
		'lblBE': 'Belgique',
		'lblNonBE': 'Autre pays',
		'lblEER': 'Pays EEE (UE27 (incl. BE) / Islande / Norvège / Liechtenstein / Suisse)',
		'lblNonEER': 'Autre pays',
		'employeeDetailText': 'Veuillez fournir les informations suivantes',
		'CountryLocationText': 'Où votre entreprise est-elle enregistrée ?',
		'EmployeeLocationText': 'Où êtes-vous enregistré ?',
		'selfEmployedText': 'Êtes-vous travailleur indépendant ?',
		'yes': 'Oui',
		'no': 'Non',
	},
	'NL': {
		'welcomeTitle': 'We hebben wat informatie nodig om uw bedrijf te valideren.',
		'welcomeReason': 'De volgende pagina zal u door dit proces leiden.',
		'finishedTitle': 'Klaar om in te dienen',
		'finishedReason': 'Na indiening zullen de door u verstrekte gegevens zorgvuldig worden beoordeeld en kunnen aanvullende controles nodig zijn.',
		'vatText': 'Geef het BTW-nummer op:',
		'lblVAT': 'BTW-nummer',
		'unknownCompanyText': 'Dit BTW-nummer wordt niet herkend en kan niet worden gevalideerd. Controleer het opnieuw of voer alle informatie handmatig in.',
		'unknownCompanyBtn': 'Doorgaan',
		'detailsText': 'Controleer en pas deze gegevens aan indien nodig:',
		'detailsUnknownText': 'Geef de volgende gegevens op',
		'scanningTitle': 'Upload uw documenten',
		'scanningText': 'Maak of selecteer een afbeelding van uw document waarbij de randen zichtbaar zijn en alle tekst duidelijk leesbaar is.',
		'errorNotRecognised': 'Document niet herkend',
		'errorWrongType': 'Verkeerd documenttype',
		'lblExpires': 'Verloopt',
		'lblUploadOrCapture': 'Upload of maak een afbeelding',
		'VATText': 'Geef uw BTW-nummer op',
		'lblBE': 'België',
		'lblNonBE': 'Ander land',
		'lblEER': 'EER-land (EU27 (incl. BE) / IJsland / Noorwegen / Liechtenstein / Zwitserland)',
		'lblNonEER': 'Ander land',
		'employeeDetailText': 'Geef de volgende informatie op',
		'CountryLocationText': 'Waar is uw bedrijf geregistreerd?',
		'EmployeeLocationText': 'Waar bent u geregistreerd?',
		'selfEmployedText': 'Bent u zelfstandig?',
		'yes': 'Ja',
		'no': 'Nee',
	},
	'DE': {
		'welcomeTitle': 'Wir benötigen einige Informationen, um Ihr Unternehmen zu validieren.',
		'welcomeReason': 'Die nächste Seite wird Sie durch diesen Prozess führen.',
		'finishedTitle': 'Bereit zum Absenden',
		'finishedReason': 'Nach dem Absenden werden die von Ihnen angegebenen Daten sorgfältig überprüft und möglicherweise zusätzliche Kontrollen durchgeführt.',
		'vatText': 'Bitte geben Sie die Umsatzsteuer-Identifikationsnummer an:',
		'lblVAT': 'USt-IdNr.',
		'unknownCompanyText': 'Diese USt-IdNr. wird nicht erkannt und kann nicht validiert werden. Bitte überprüfen Sie sie erneut oder geben Sie alle Informationen manuell ein.',
		'unknownCompanyBtn': 'Fortfahren',
		'detailsText': 'Bitte überprüfen und passen Sie diese Details gegebenenfalls an:',
		'detailsUnknownText': 'Bitte geben Sie die folgenden Details an',
		'scanningTitle': 'Laden Sie Ihre Dokumente hoch',
		'scanningText': 'Erfassen oder wählen Sie ein Bild Ihres Dokuments, bei dem die Ränder sichtbar und der gesamte Text deutlich lesbar ist.',
		'errorNotRecognised': 'Dokument nicht erkannt',
		'errorWrongType': 'Falscher Dokumenttyp',
		'lblExpires': 'Läuft ab',
		'lblUploadOrCapture': 'Bild hochladen oder erfassen',
		'VATText': 'Bitte geben Sie Ihre USt-IdNr. an',
		'lblBE': 'Belgien',
		'lblNonBE': 'Anderes Land',
		'lblEER': 'EWR-Land (EU27 (inkl. BE) / Island / Norwegen / Liechtenstein / Schweiz)',
		'lblNonEER': 'Anderes Land',
		'employeeDetailText': 'Bitte geben Sie die folgenden Informationen an',
		'CountryLocationText': 'Wo ist Ihr Unternehmen registriert?',
		'EmployeeLocationText': 'Wo sind Sie registriert?',
		'selfEmployedText': 'Sind Sie selbstständig?',
		'yes': 'Ja',
		'no': 'Nein',
	},
	'PL': {
		'welcomeTitle': 'Potrzebujemy kilku informacji, aby zweryfikować Twoją firmę.',
		'welcomeReason': 'Następna strona przeprowadzi Cię przez ten proces.',
		'finishedTitle': 'Gotowe do wysłania',
		'finishedReason': 'Po wysłaniu, podane przez Ciebie dane zostaną dokładnie sprawdzone i mogą być konieczne dodatkowe weryfikacje.',
		'vatText': 'Proszę podać numer VAT:',
		'lblVAT': 'Numer VAT',
		'unknownCompanyText': 'Ten numer VAT nie jest rozpoznawany i nie może być zweryfikowany, proszę sprawdzić ponownie lub wprowadzić wszystkie informacje ręcznie.',
		'unknownCompanyBtn': 'Kontynuuj',
		'detailsText': 'Proszę sprawdzić i dostosować te szczegóły, jeśli to konieczne:',
		'detailsUnknownText': 'Proszę podać następujące szczegóły',
		'scanningTitle': 'Prześlij swoje dokumenty',
		'scanningText': 'Zrób lub wybierz zdjęcie swojego dokumentu, na którym widoczne są krawędzie i cały tekst jest wyraźnie czytelny.',
		'errorNotRecognised': 'Dokument nierozpoznany',
		'errorWrongType': 'Niewłaściwy typ dokumentu',
		'lblExpires': 'Wygasa',
		'lblUploadOrCapture': 'Prześlij lub zrób zdjęcie',
		'VATText': 'Proszę podać swój numer VAT',
		'lblBE': 'Belgia',
		'lblNonBE': 'Inny kraj',
		'lblEER': 'Kraj EOG (UE27 (w tym BE) / Islandia / Norwegia / Liechtenstein / Szwajcaria)',
		'lblNonEER': 'Inny kraj',
		'employeeDetailText': 'Proszę podać następujące informacje',
		'CountryLocationText': 'Gdzie jest zarejestrowana Twoja firma?',
		'EmployeeLocationText': 'Gdzie jesteś zarejestrowany?',
		'selfEmployedText': 'Czy jesteś samozatrudniony?',
		'yes': 'Tak',
		'no': 'Nie',
	},
	'BG': {
		'welcomeTitle': 'Нуждаем се от малко информация, за да валидираме вашата компания.',
		'welcomeReason': 'Следващата страница ще ви насочи през този процес.',
		'finishedTitle': 'Готово за изпращане',
		'finishedReason': 'При изпращане, предоставените данни ще бъдат внимателно прегледани и може да са необходими допълнителни проверки.',
		'vatText': 'Моля, предоставете номер за ДДС:',
		'lblVAT': 'Номер за ДДС',
		'unknownCompanyText': 'Този номер за ДДС не е разпознат и не може да бъде валидиран, моля проверете отново или въведете цялата информация ръчно.',
		'unknownCompanyBtn': 'Продължи',
		'detailsText': 'Моля, прегледайте и коригирайте тези данни, ако е необходимо:',
		'detailsUnknownText': 'Моля, предоставете следните данни',
		'scanningTitle': 'Качете вашите документи',
		'scanningText': 'Направете или изберете снимка на документа, където краищата са видими и целият текст е ясно четим.',
		'errorNotRecognised': 'Документът не е разпознат',
		'errorWrongType': 'Грешен тип документ',
		'lblExpires': 'Изтича',
		'lblUploadOrCapture': 'Качете или направете снимка',
		'VATText': 'Моля, предоставете вашия номер за ДДС',
		'lblBE': 'Белгия',
		'lblNonBE': 'Друга държава',
		'lblEER': 'Държава от ЕИП (ЕС27 (включва BE) / Исландия / Норвегия / Лихтенщайн / Швейцария)',
		'lblNonEER': 'Друга държава',
		'employeeDetailText': 'Моля, предоставете следната информация',
		'CountryLocationText': 'Къде е регистрирана вашата компания?',
		'EmployeeLocationText': 'Къде сте регистриран?',
		'selfEmployedText': 'Сте ли със свободна професия?',
		'yes': 'Да',
		'no': 'Не',
	},
	'CS': {
		'welcomeTitle': 'Potřebujeme některé informace k ověření vaší společnosti.',
		'welcomeReason': 'Další stránka vás provede tímto procesem.',
		'finishedTitle': 'Připraveno k odeslání',
		'finishedReason': 'Po odeslání budou poskytnuté údaje pečlivě zkontrolovány a mohou být nutné další kontroly.',
		'vatText': 'Uveďte prosím DIČ:',
		'lblVAT': 'DIČ',
		'unknownCompanyText': 'Toto DIČ není rozpoznáno a nelze ho ověřit, zkontrolujte prosím znovu nebo zadejte všechny informace ručně.',
		'unknownCompanyBtn': 'Pokračovat',
		'detailsText': 'Zkontrolujte a upravte tyto podrobnosti, pokud je to nutné:',
		'detailsUnknownText': 'Uveďte prosím následující údaje',
		'scanningTitle': 'Nahrajte své dokumenty',
		'scanningText': 'Pořiďte nebo vyberte obrázek vašeho dokumentu, kde jsou okraje viditelné a veškerý text je jasně čitelný.',
		'errorNotRecognised': 'Dokument nerozpoznán',
		'errorWrongType': 'Špatný typ dokumentu',
		'lblExpires': 'Vyprší',
		'lblUploadOrCapture': 'Nahrát nebo pořídit obrázek',
		'VATText': 'Uveďte prosím své DIČ',
		'lblBE': 'Belgie',
		'lblNonBE': 'Jiná země',
		'lblEER': 'Země EHP (EU27 (vč. BE) / Island / Norsko / Lichtenštejnsko / Švýcarsko)',
		'lblNonEER': 'Jiná země',
		'employeeDetailText': 'Uveďte prosím následující informace',
		'CountryLocationText': 'Kde je vaše společnost registrována?',
		'EmployeeLocationText': 'Kde jste registrováni?',
		'selfEmployedText': 'Jste OSVČ?',
		'yes': 'Ano',
		'no': 'Ne',
	},
	'DA': {
		'welcomeTitle': 'Vi har brug for nogle oplysninger for at validere jeres virksomhed.',
		'welcomeReason': 'Næste side vil guide dig gennem denne proces.',
		'finishedTitle': 'Klar til at indsende',
		'finishedReason': 'Ved indsendelse vil de data, du har angivet, blive gennemgået nøje, og der kan være behov for yderligere kontroller.',
		'vatText': 'Angiv venligst CVR-nummeret:',
		'lblVAT': 'CVR-nummer',
		'unknownCompanyText': 'Dette CVR-nummer genkendes ikke og kan ikke valideres. Kontrollér venligst igen eller indtast alle oplysninger manuelt.',
		'unknownCompanyBtn': 'Fortsæt',
		'detailsText': 'Gennemgå venligst og justér disse detaljer, hvis det er nødvendigt:',
		'detailsUnknownText': 'Angiv venligst følgende oplysninger',
		'scanningTitle': 'Upload dine dokumenter',
		'scanningText': 'Tag eller vælg et billede af dit dokument, hvor kanterne er synlige og al tekst er tydeligt læsbar.',
		'errorNotRecognised': 'Dokument ikke genkendt',
		'errorWrongType': 'Forkert dokumenttype',
		'lblExpires': 'Udløber',
		'lblUploadOrCapture': 'Upload eller tag et billede',
		'VATText': 'Angiv venligst dit CVR-nummer',
		'lblBE': 'Belgien',
		'lblNonBE': 'Andet land',
		'lblEER': 'EØS-land (EU27 (inkl. BE) / Island / Norge / Liechtenstein / Schweiz)',
		'lblNonEER': 'Andet land',
		'employeeDetailText': 'Angiv venligst følgende oplysninger',
		'CountryLocationText': 'Hvor er jeres virksomhed registreret?',
		'EmployeeLocationText': 'Hvor er du registreret?',
		'selfEmployedText': 'Er du selvstændig?',
		'yes': 'Ja',
		'no': 'Nej',
	},
	'ES': {
		'welcomeTitle': 'Necesitamos alguna información para validar su empresa.',
		'welcomeReason': 'La siguiente página le guiará a través de este proceso.',
		'finishedTitle': 'Listo para enviar',
		'finishedReason': 'Al enviar, los datos proporcionados serán revisados cuidadosamente y podrían ser necesarias verificaciones adicionales.',
		'vatText': 'Proporcione el número de IVA:',
		'lblVAT': 'Número de IVA',
		'unknownCompanyText': 'Este número de IVA no es reconocido y no se puede validar. Por favor, verifique nuevamente o ingrese toda la información manualmente.',
		'unknownCompanyBtn': 'Continuar',
		'detailsText': 'Revise y ajuste estos detalles si es necesario:',
		'detailsUnknownText': 'Proporcione los siguientes datos',
		'scanningTitle': 'Sube tus documentos',
		'scanningText': 'Captura o selecciona una imagen de tu documento donde los bordes sean visibles y todo el texto esté claramente legible.',
		'errorNotRecognised': 'Documento no reconocido',
		'errorWrongType': 'Tipo de documento incorrecto',
		'lblExpires': 'Vence',
		'lblUploadOrCapture': 'Sube o captura una imagen',
		'VATText': 'Proporcione su número de IVA',
		'lblBE': 'Bélgica',
		'lblNonBE': 'Otro país',
		'lblEER': 'País del EEE (UE27 (incl. BE) / Islandia / Noruega / Liechtenstein / Suiza)',
		'lblNonEER': 'Otro país',
		'employeeDetailText': 'Proporcione la siguiente información',
		'CountryLocationText': '¿Dónde está registrada su empresa?',
		'EmployeeLocationText': '¿Dónde está usted registrado?',
		'selfEmployedText': '¿Es usted autónomo?',
		'yes': 'Sí',
		'no': 'No',
	},
	'FI': {
		'welcomeTitle': 'Tarvitsemme vähän tietoja yrityksenne validoimiseksi.',
		'welcomeReason': 'Seuraava sivu opastaa sinut tämän prosessin läpi.',
		'finishedTitle': 'Valmis lähettämään',
		'finishedReason': 'Lähettämisen jälkeen antamasi tiedot tarkistetaan huolellisesti ja mahdollisia lisätarkistuksia voi olla tarpeen.',
		'vatText': 'Anna ALV-numero:',
		'lblVAT': 'ALV-numero',
		'unknownCompanyText': 'Tämä ALV-numeroa ei tunnisteta eikä sitä voida validoida. Tarkista se uudelleen tai syötä kaikki tiedot manuaalisesti.',
		'unknownCompanyBtn': 'Jatka',
		'detailsText': 'Tarkista ja muokkaa näitä tietoja tarvittaessa:',
		'detailsUnknownText': 'Anna seuraavat tiedot',
		'scanningTitle': 'Lataa asiakirjasi',
		'scanningText': 'Ota tai valitse kuva asiakirjastasi, jossa reunat ovat näkyvissä ja kaikki teksti on selkeästi luettavissa.',
		'errorNotRecognised': 'Asiakirjaa ei tunnistettu',
		'errorWrongType': 'Väärä asiakirjatyppi',
		'lblExpires': 'Vanhenee',
		'lblUploadOrCapture': 'Lataa tai ota kuva',
		'VATText': 'Anna ALV-numerosi',
		'lblBE': 'Belgia',
		'lblNonBE': 'Muu maa',
		'lblEER': 'ETA-maa (EU27 (sis. BE) / Islanti / Norja / Liechtenstein / Sveitsi)',
		'lblNonEER': 'Muu maa',
		'employeeDetailText': 'Anna seuraavat tiedot',
		'CountryLocationText': 'Missä yrityksenne on rekisteröity?',
		'EmployeeLocationText': 'Missä olette rekisteröity?',
		'selfEmployedText': 'Oletko yrittäjä?',
		'yes': 'Kyllä',
		'no': 'Ei',
	},
	'HR': {
		'welcomeTitle': 'Trebamo nekoliko informacija kako bismo validirali vašu tvrtku.',
		'welcomeReason': 'Sljedeća stranica će vas provesti kroz ovaj proces.',
		'finishedTitle': 'Spremno za slanje',
		'finishedReason': 'Po slanju, podaci koje ste naveli bit će pažljivo pregledani i mogu biti potrebne dodatne provjere.',
		'vatText': 'Molimo navedite OIB:',
		'lblVAT': 'OIB',
		'unknownCompanyText': 'Ovaj OIB nije prepoznat i ne može biti validiran, molimo provjerite ponovno ili unesite sve informacije ručno.',
		'unknownCompanyBtn': 'Nastavi',
		'detailsText': 'Molimo pregledajte i prilagodite ove detalje ako je potrebno:',
		'detailsUnknownText': 'Molimo navedite sljedeće podatke',
		'scanningTitle': 'Učitajte svoje dokumente',
		'scanningText': 'Snimite ili odaberite sliku vašeg dokumenta gdje su rubovi vidljivi i sav tekst je jasno čitljiv.',
		'errorNotRecognised': 'Dokument nije prepoznat',
		'errorWrongType': 'Pogrešan tip dokumenta',
		'lblExpires': 'Istječe',
		'lblUploadOrCapture': 'Učitaj ili snimi sliku',
		'VATText': 'Molimo navedite svoj OIB',
		'lblBE': 'Belgija',
		'lblNonBE': 'Druga država',
		'lblEER': 'EEA država (EU27 (uklj. BE) / Island / Norveška / Lihtenštajn / Švicarska)',
		'lblNonEER': 'Druga država',
		'employeeDetailText': 'Molimo navedite sljedeće informacije',
		'CountryLocationText': 'Gdje je vaša tvrtka registrirana?',
		'EmployeeLocationText': 'Gdje ste registrirani?',
		'selfEmployedText': 'Jeste li samozaposleni?',
		'yes': 'Da',
		'no': 'Ne',
	},
	'HU': {
		'welcomeTitle': 'Szükségünk van néhány információra a vállalkozása ellenőrzéséhez.',
		'welcomeReason': 'A következő oldal végigvezeti ezen a folyamaton.',
		'finishedTitle': 'Készen áll a benyújtásra',
		'finishedReason': 'A benyújtás után a megadott adatokat gondosan átnézik, és további ellenőrzések szükségesek lehetnek.',
		'vatText': 'Kérjük, adja meg az ÁFA-számot:',
		'lblVAT': 'ÁFA-szám',
		'unknownCompanyText': 'Ez az ÁFA-szám nem ismerhető fel és nem validálható. Kérjük, ellenőrizze újra vagy adja meg az összes információt manuálisan.',
		'unknownCompanyBtn': 'Folytatás',
		'detailsText': 'Kérjük, ellenőrizze és szükség esetén módosítsa ezeket a részleteket:',
		'detailsUnknownText': 'Kérjük, adja meg a következő adatokat',
		'scanningTitle': 'Töltse fel dokumentumait',
		'scanningText': 'Készítsen vagy válasszon egy képet a dokumentumáról, ahol a szélek láthatók és az összes szöveg jól olvasható.',
		'errorNotRecognised': 'Dokumentum nem felismerhető',
		'errorWrongType': 'Hibás dokumentumtípus',
		'lblExpires': 'Lejár',
		'lblUploadOrCapture': 'Feltöltés vagy kép készítése',
		'VATText': 'Kérjük, adja meg az ÁFA-számát',
		'lblBE': 'Belgium',
		'lblNonBE': 'Másik ország',
		'lblEER': 'EGT ország (EU27 (BE-t is beleértve) / Izland / Norvégia / Liechtenstein / Svájc)',
		'lblNonEER': 'Másik ország',
		'employeeDetailText': 'Kérjük, adja meg a következő információkat',
		'CountryLocationText': 'Hol van a vállalkozása bejegyezve?',
		'EmployeeLocationText': 'Hol van bejegyezve?',
		'selfEmployedText': 'Ön vállalkozó?',
		'yes': 'Igen',
		'no': 'Nem',
	},
	'IT': {
		'welcomeTitle': 'Abbiamo bisogno di alcune informazioni per validare la vostra azienda.',
		'welcomeReason': 'La pagina seguente vi guiderà attraverso questo processo.',
		'finishedTitle': 'Pronto per l\'invio',
		'finishedReason': 'All\'invio, i dati forniti saranno attentamente revisionati e potrebbero essere necessarie verifiche aggiuntive.',
		'vatText': 'Si prega di fornire la partita IVA:',
		'lblVAT': 'Partita IVA',
		'unknownCompanyText': 'Questa partita IVA non è riconosciuta e non può essere validata. Si prega di verificare di nuovo o inserire tutte le informazioni manualmente.',
		'unknownCompanyBtn': 'Continua',
		'detailsText': 'Si prega di rivedere e regolare questi dettagli, se necessario:',
		'detailsUnknownText': 'Si prega di fornire i seguenti dettagli',
		'scanningTitle': 'Carica i tuoi documenti',
		'scanningText': 'Cattura o seleziona un\'immagine del tuo documento dove i bordi sono visibili e tutto il testo è chiaramente leggibile.',
		'errorNotRecognised': 'Documento non riconosciuto',
		'errorWrongType': 'Tipo di documento errato',
		'lblExpires': 'Scade',
		'lblUploadOrCapture': 'Carica o cattura un\'immagine',
		'VATText': 'Si prega di fornire la propria partita IVA',
		'lblBE': 'Belgio',
		'lblNonBE': 'Altro paese',
		'lblEER': 'Paese SEE (UE27 (incl. BE) / Islanda / Norvegia / Liechtenstein / Svizzera)',
		'lblNonEER': 'Altro paese',
		'employeeDetailText': 'Si prega di fornire le seguenti informazioni',
		'CountryLocationText': 'Dove è registrata la vostra azienda?',
		'EmployeeLocationText': 'Dove sei registrato?',
		'selfEmployedText': 'Sei lavoratore autonomo?',
		'yes': 'Sì',
		'no': 'No',
	},
	'NO': {
		'welcomeTitle': 'Vi trenger litt informasjon for å validere bedriften deres.',
		'welcomeReason': 'Neste side vil guide deg gjennom denne prosessen.',
		'finishedTitle': 'Klar til innsending',
		'finishedReason': 'Ved innsending vil de dataene du har oppgitt bli nøye gjennomgått, og det kan være behov for ytterligere kontroller.',
		'vatText': 'Angi vennligst VAT-nummeret:',
		'lblVAT': 'VAT-nummer',
		'unknownCompanyText': 'Dette VAT-nummeret er ikke godkjent og kan ikke valideres. Kontroller det på nytt eller oppgi all informasjon manuelt.',
		'unknownCompanyBtn': 'Fortsett',
		'detailsText': 'Gjennomgå og juster disse detaljene om nødvendig:',
		'detailsUnknownText': 'Oppgi følgende opplysninger',
		'scanningTitle': 'Last opp dokumentene dine',
		'scanningText': 'Ta eller velg et bilde av dokumentet ditt hvor kantene er synlige og all tekst er tydelig lesbar.',
		'errorNotRecognised': 'Dokument ikke gjenkjent',
		'errorWrongType': 'Feil dokumenttype',
		'lblExpires': 'Utløper',
		'lblUploadOrCapture': 'Last opp eller ta et bilde',
		'VATText': 'Angi vennligst ditt VAT-nummer',
		'lblBE': 'Belgia',
		'lblNonBE': 'Annet land',
		'lblEER': 'EØS-land (EU27 (inkl. BE) / Island / Norge / Liechtenstein / Sveits)',
		'lblNonEER': 'Annet land',
		'employeeDetailText': 'Oppgi følgende informasjon',
		'CountryLocationText': 'Hvor er bedriften deres registrert?',
		'EmployeeLocationText': 'Hvor er du registrert?',
		'selfEmployedText': 'Er du selvstendig næringsdrivende?',
		'yes': 'Ja',
		'no': 'Nei',
	},
	'PT': {
		'welcomeTitle': 'Precisamos de algumas informações para validar a sua empresa.',
		'welcomeReason': 'A próxima página o guiará através deste processo.',
		'finishedTitle': 'Pronto para enviar',
		'finishedReason': 'Ao enviar, os dados fornecidos serão cuidadosamente revisados e verificações adicionais poderão ser necessárias.',
		'vatText': 'Por favor, forneça o número de IVA:',
		'lblVAT': 'Número de IVA',
		'unknownCompanyText': 'Este número de IVA não é reconhecido e não pode ser validado. Por favor, verifique novamente ou insira todas as informações manualmente.',
		'unknownCompanyBtn': 'Continuar',
		'detailsText': 'Revise e ajuste estes detalhes, se necessário:',
		'detailsUnknownText': 'Por favor, forneça os seguintes detalhes',
		'scanningTitle': 'Faça upload dos seus documentos',
		'scanningText': 'Capture ou selecione uma imagem do seu documento onde as bordas estão visíveis e todo o texto está claramente legível.',
		'errorNotRecognised': 'Documento não reconhecido',
		'errorWrongType': 'Tipo de documento incorreto',
		'lblExpires': 'Expira',
		'lblUploadOrCapture': 'Carregar ou capturar uma imagem',
		'VATText': 'Por favor, forneça o seu número de IVA',
		'lblBE': 'Bélgica',
		'lblNonBE': 'Outro país',
		'lblEER': 'País do EEE (UE27 (incl. BE) / Islândia / Noruega / Liechtenstein / Suíça)',
		'lblNonEER': 'Outro país',
		'employeeDetailText': 'Por favor, forneça as seguintes informações',
		'CountryLocationText': 'Onde está a sua empresa registrada?',
		'EmployeeLocationText': 'Onde você está registrado?',
		'selfEmployedText': 'Você é trabalhador autônomo?',
		'yes': 'Sim',
		'no': 'Não',
	},
	'RO': {
		'welcomeTitle': 'Avem nevoie de câteva informații pentru a valida compania dvs.',
		'welcomeReason': 'Următoarea pagină vă va ghida prin acest proces.',
		'finishedTitle': 'Gata de trimis',
		'finishedReason': 'La trimitere, datele furnizate vor fi examinate cu atenție și pot fi necesare verificări suplimentare.',
		'vatText': 'Vă rugăm să furnizați numărul de TVA:',
		'lblVAT': 'Număr de TVA',
		'unknownCompanyText': 'Acest număr de TVA nu este recunoscut și nu poate fi validat. Vă rugăm să verificați din nou sau introduceți toate informațiile manual.',
		'unknownCompanyBtn': 'Continuă',
		'detailsText': 'Vă rugăm să revizuiți și să ajustați aceste detalii, dacă este necesar:',
		'detailsUnknownText': 'Vă rugăm să furnizați următoarele detalii',
		'scanningTitle': 'Încărcați documentele',
		'scanningText': 'Captați sau selectați o imagine a documentului dvs. unde marginile sunt vizibile și tot textul este clar lizibil.',
		'errorNotRecognised': 'Document nerecunoscut',
		'errorWrongType': 'Tip de document incorect',
		'lblExpires': 'Expiră',
		'lblUploadOrCapture': 'Încărcați sau capturați o imagine',
		'VATText': 'Vă rugăm să furnizați numărul dvs. de TVA',
		'lblBE': 'Belgia',
		'lblNonBE': 'Altă țară',
		'lblEER': 'Țară EEA (UE27 (incl. BE) / Islanda / Norvegia / Liechtenstein / Elveția)',
		'lblNonEER': 'Altă țară',
		'employeeDetailText': 'Vă rugăm să furnizați următoarele informații',
		'CountryLocationText': 'Unde este înregistrată compania dvs.?',
		'EmployeeLocationText': 'Unde sunteți înregistrat?',
		'selfEmployedText': 'Sunteți persoană fizică autorizată?',
		'yes': 'Da',
		'no': 'Nu',
	},
	'RU': {
		'welcomeTitle': 'Нам нужна информация для подтверждения вашей компании.',
		'welcomeReason': 'Следующая страница проведет вас через этот процесс.',
		'finishedTitle': 'Готово к отправке',
		'finishedReason': 'При отправке предоставленные данные будут тщательно проверены, могут потребоваться дополнительные проверки.',
		'vatText': 'Укажите номер НДС:',
		'lblVAT': 'Номер НДС',
		'unknownCompanyText': 'Этот номер НДС не распознан и не может быть подтвержден. Пожалуйста, проверьте еще раз или введите всю информацию вручную.',
		'unknownCompanyBtn': 'Продолжить',
		'detailsText': 'Пожалуйста, просмотрите и при необходимости скорректируйте эти данные:',
		'detailsUnknownText': 'Пожалуйста, предоставьте следующие данные',
		'scanningTitle': 'Загрузите ваши документы',
		'scanningText': 'Сделайте или выберите изображение вашего документа, где края видны и весь текст четко читаем.',
		'errorNotRecognised': 'Документ не распознан',
		'errorWrongType': 'Неправильный тип документа',
		'lblExpires': 'Истекает',
		'lblUploadOrCapture': 'Загрузить или сделать изображение',
		'VATText': 'Пожалуйста, укажите ваш номер НДС',
		'lblBE': 'Бельгия',
		'lblNonBE': 'Другая страна',
		'lblEER': 'Страна ЕЭП (ЕС27 (включ. BE) / Исландия / Норвегия / Лихтенштейн / Швейцария)',
		'lblNonEER': 'Другая страна',
		'employeeDetailText': 'Пожалуйста, предоставьте следующую информацию',
		'CountryLocationText': 'Где зарегистрирована ваша компания?',
		'EmployeeLocationText': 'Где вы зарегистрированы?',
		'selfEmployedText': 'Вы индивидуальный предприниматель?',
		'yes': 'Да',
		'no': 'Нет',
	},
	'SK': {
		'welcomeTitle': 'Potrebujeme nejaké informácie na overenie vašej spoločnosti.',
		'welcomeReason': 'Ďalšia stránka vás prevedie týmto procesom.',
		'finishedTitle': 'Pripravené na odoslanie',
		'finishedReason': 'Po odoslaní budú poskytnuté údaje dôkladne preskúmané a môžu byť potrebné dodatočné kontroly.',
		'vatText': 'Uveďte prosím DIČ:',
		'lblVAT': 'DIČ',
		'unknownCompanyText': 'Toto DIČ nie je rozpoznané a nemôže byť overené. Skontrolujte to prosím znova alebo zadajte všetky informácie ručne.',
		'unknownCompanyBtn': 'Pokračovať',
		'detailsText': 'Skontrolujte a upravte tieto podrobnosti, ak je to nutné:',
		'detailsUnknownText': 'Uveďte prosím nasledujúce údaje',
		'scanningTitle': 'Nahrajte svoje dokumenty',
		'scanningText': 'Zhotovte alebo vyberte obrázok dokumentu, kde sú okraje viditeľné a všetok text je jasne čitateľný.',
		'errorNotRecognised': 'Dokument nebol rozpoznaný',
		'errorWrongType': 'Nesprávny typ dokumentu',
		'lblExpires': 'Vyprší',
		'lblUploadOrCapture': 'Nahrať alebo urobiť obrázok',
		'VATText': 'Uveďte prosím svoje DIČ',
		'lblBE': 'Belgicko',
		'lblNonBE': 'Iná krajina',
		'lblEER': 'EHP krajina (EU27 (vrátane BE) / Island / Nórsko / Lichtenštajnsko / Švajčiarsko)',
		'lblNonEER': 'Iná krajina',
		'employeeDetailText': 'Uveďte prosím nasledujúce informácie',
		'CountryLocationText': 'Kde je vaša spoločnosť registrovaná?',
		'EmployeeLocationText': 'Kde ste registrovaní?',
		'selfEmployedText': 'Ste SZČO?',
		'yes': 'Áno',
		'no': 'Nie',
	},
	'SI': {
		'welcomeTitle': 'Potrebujemo nekaj informacij za preverjanje vašega podjetja.',
		'welcomeReason': 'Naslednja stran vas bo popeljevala skozi ta postopek.',
		'finishedTitle': 'Pripravljeno za oddajo',
		'finishedReason': 'Po oddaji bodo navedeni podatki skrbno pregledani in morda bodo potrebne dodatne preveritve.',
		'vatText': 'Prosimo, navedite ID za DDV:',
		'lblVAT': 'ID za DDV',
		'unknownCompanyText': 'Ta ID za DDV ni prepoznan in ni mogoče validirati. Prosimo, preverite ponovno ali vnesite vse informacije ročno.',
		'unknownCompanyBtn': 'Nadaljuj',
		'detailsText': 'Prosimo, pregledajte in prilagodite te podrobnosti, če je potrebno:',
		'detailsUnknownText': 'Prosimo, navedite naslednje podrobnosti',
		'scanningTitle': 'Naložite svoje dokumente',
		'scanningText': 'Ustvarite ali izberite sliko dokumenta, kjer so robovi vidni in ves tekst jasno berljiv.',
		'errorNotRecognised': 'Dokument ni prepoznan',
		'errorWrongType': 'Napačna vrsta dokumenta',
		'lblExpires': 'Izteče',
		'lblUploadOrCapture': 'Naložite ali naredite sliko',
		'VATText': 'Prosimo, navedite svoj ID za DDV',
		'lblBE': 'Belgija',
		'lblNonBE': 'Druga država',
		'lblEER': 'Država EGP (EU27 (vklj. BE) / Islandija / Norveška / Lihtenštajn / Švica)',
		'lblNonEER': 'Druga država',
		'employeeDetailText': 'Prosimo, navedite naslednje informacije',
		'CountryLocationText': 'Kje je registrirano vaše podjetje?',
		'EmployeeLocationText': 'Kje ste registrirani?',
		'selfEmployedText': 'Ali ste samostojni podjetnik?',
		'yes': 'Da',
		'no': 'Ne',
	},
	'SV': {
		'welcomeTitle': 'Vi behöver lite information för att verifiera ditt företag.',
		'welcomeReason': 'Nästa sida kommer att guida dig genom denna process.',
		'finishedTitle': 'Redo att skicka',
		'finishedReason': 'Vid skickande kommer de uppgifter du har angett att noggrant granskas och ytterligare kontroller kan vara nödvändiga.',
		'vatText': 'Ange momsregistreringsnummer:',
		'lblVAT': 'Momsregistreringsnummer',
		'unknownCompanyText': 'Detta momsregistreringsnummer känns inte igen och kan inte verifieras. Kontrollera igen eller ange all information manuellt.',
		'unknownCompanyBtn': 'Fortsätt',
		'detailsText': 'Granska och justera dessa uppgifter vid behov:',
		'detailsUnknownText': 'Ange följande uppgifter',
		'scanningTitle': 'Ladda upp dina dokument',
		'scanningText': 'Fånga eller välj en bild av ditt dokument där kanterna är synliga och all text är tydligt läsbar.',
		'errorNotRecognised': 'Dokument inte igenkänt',
		'errorWrongType': 'Fel dokumenttyp',
		'lblExpires': 'Förfaller',
		'lblUploadOrCapture': 'Ladda upp eller fånga en bild',
		'VATText': 'Ange ditt momsregistreringsnummer',
		'lblBE': 'Belgien',
		'lblNonBE': 'Annan nation',
		'lblEER': 'EES-land (EU27 (inkl. BE) / Island / Norge / Liechtenstein / Schweiz)',
		'lblNonEER': 'Annan nation',
		'employeeDetailText': 'Ange följande information',
		'CountryLocationText': 'Var är ditt företag registrerat?',
		'EmployeeLocationText': 'Var är du registrerad?',
		'selfEmployedText': 'Är du egenföretagare?',
		'yes': 'Ja',
		'no': 'Nej',
	},
	'TR': {
		'welcomeTitle': 'Şirketinizi doğrulamak için bilgilere ihtiyacımız var.',
		'welcomeReason': 'Sonraki sayfa size bu süreçte rehberlik edecektir.',
		'finishedTitle': 'Göndermeye hazır',
		'finishedReason': 'Gönderildiğinde, sağladığınız veriler dikkatle incelenecek ve ek kontroller gerekebilir.',
		'vatText': 'KDV numarasını girin:',
		'lblVAT': 'KDV numarası',
		'unknownCompanyText': 'Bu KDV numarası tanınmıyor ve doğrulanamıyor. Lütfen tekrar kontrol edin veya tüm bilgileri manuel olarak girin.',
		'unknownCompanyBtn': 'Devam',
		'detailsText': 'Bu ayrıntıları gözden geçirin ve gerekiyorsa ayarlayın:',
		'detailsUnknownText': 'Lütfen aşağıdaki ayrıntıları sağlayın',
		'scanningTitle': 'Belgelerinizi yükleyin',
		'scanningText': 'Kenarların görünür olduğu ve tüm metnin açıkça okunabilir olduğu belgenizin bir görüntüsünü çekin veya seçin.',
		'errorNotRecognised': 'Belge tanınmadı',
		'errorWrongType': 'Yanlış belge türü',
		'lblExpires': 'Doluyor',
		'lblUploadOrCapture': 'Yükle veya fotoğraf çek',
		'VATText': 'KDV numaranızı girin',
		'lblBE': 'Belçika',
		'lblNonBE': 'Diğer ülke',
		'lblEER': 'AEA ülkesi (AB27 (BE dahil) / İzlanda / Norveç / Liechtenstein / İsviçre)',
		'lblNonEER': 'Diğer ülke',
		'employeeDetailText': 'Lütfen aşağıdaki bilgileri sağlayın',
		'CountryLocationText': 'Şirketiniz nerede kayıtlı?',
		'EmployeeLocationText': 'Nerede kayıtlısınız?',
		'selfEmployedText': 'Serbest meslek sahibi misiniz?',
		'yes': 'Evet',
		'no': 'Hayır',
	},
	'UK': {
		'welcomeTitle': 'Нам потрібна інформація для підтвердження вашої компанії.',
		'welcomeReason': 'Наступна сторінка проведеть вас через цей процес.',
		'finishedTitle': 'Готово до відправлення',
		'finishedReason': 'Після відправлення надані дані будуть ретельно перевірені та може знадобитися додаткова перевірка.',
		'vatText': 'Будь ласка, надайте номер ПДВ:',
		'lblVAT': 'Номер ПДВ',
		'unknownCompanyText': 'Цей номер ПДВ не розпізнано і не можна підтвердити. Будь ласка, перевірте знову або введіть всю інформацію вручну.',
		'unknownCompanyBtn': 'Продовжити',
		'detailsText': 'Будь ласка, перевірте та при необхідності скоригуйте ці дані:',
		'detailsUnknownText': 'Будь ласка, надайте такі дані',
		'scanningTitle': 'Завантажте ваші документи',
		'scanningText': 'Зробіть або виберіть зображення вашого документа, де краї видні і весь текст чітко читається.',
		'errorNotRecognised': 'Документ не розпізнано',
		'errorWrongType': 'Неправильний тип документа',
		'lblExpires': 'Закінчується',
		'lblUploadOrCapture': 'Завантажити або зробити фото',
		'VATText': 'Будь ласка, надайте ваш номер ПДВ',
		'lblBE': 'Бельгія',
		'lblNonBE': 'Інша країна',
		'lblEER': 'Країна ЄЕЗ (ЄС27 (включ. BE) / Ісландія / Норвегія / Ліхтенштейн / Швейцарія)',
		'lblNonEER': 'Інша країна',
		'employeeDetailText': 'Будь ласка, надайте таку інформацію',
		'CountryLocationText': 'Де зареєстрована ваша компанія?',
		'EmployeeLocationText': 'Де ви зареєстровані?',
		'selfEmployedText': 'Ви самозайнятий?',
		'yes': 'Так',
		'no': 'Ні',
	}
};


export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}